var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('top-navigation-bar'),_c('side-menu'),_c('v-main',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }